import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import Navbar from "react-bootstrap/Navbar";
import './styles.scss';
import { useTranslation } from 'react-i18next';
import LocaleModal from '../LocaleModal';
import { getCurrencies } from "../../redux/currencies/action";
import { setVendorsLoaded } from "../../redux/vendors/action";
import { setResultsLoaded } from "../../redux/results/action";
import Login from '../Login';
import RecentSearchesModal from '../RecentSearchesModal';
import { FaHistory } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import { dismissCoachmark } from '../../redux/recentSearches/recentSearchesSlice';
import './CoachmarkBubble.scss';
import MyHelmet from '../MyHelmet';
import LanguageSuggestionBanner from '../LanguageSuggestionBanner';
import { useHistory, useLocation } from 'react-router-dom';
import routes from '../../constants/routes.json';
import { trackEvent } from '../../utils/analytics';
import { buildResumeQuery, buildStartOverQuery } from '../../utils/searchQuery';

const Header = ({ dispatch, dir, cid, locations }) => {
  const [showLocaleModal, setShowLocaleModal] = useState(false);
  const [showRecentSearchesModal, setShowRecentSearchesModal] = useState(false);
  const [hasHistory, setHasHistory] = useState(false);
  const [showCoachmark, setShowCoachmark] = useState(false);
  const historyBtnRef = useRef(null);

  // console.log('render header')
  const { t, i18n } = useTranslation(); // eslint-disable-line
  const rtl = dir === 'rtl';
  const lng = i18n.language;

  const dispatchRedux = useDispatch();
  const recentSearches = useSelector(state => state.recentSearches.recent);
  const coachmarkDismissed = useSelector(state => state.recentSearches.coachmarkDismissed);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // console.log("Fetching currencies once only...");
    dispatch(getCurrencies({ force: "dummyforce" }));
  }, []);

  useEffect(() => {
    setHasHistory(Array.isArray(recentSearches) && recentSearches.length > 1);
    // Show coachmark as soon as menu becomes available and not dismissed
    if (Array.isArray(recentSearches) && recentSearches.length > 1 && !coachmarkDismissed) {
      setShowCoachmark(true);
    } else {
      setShowCoachmark(false);
    }
  }, [recentSearches, coachmarkDismissed]);

  // Track menu clicks
  const trackMenuClick = (label) => {
    trackEvent('Menu Click', {
      event_category: 'Menu',
      event_label: label
    });
  };

  const openSearchPage = (search) => {
    // Reset loaded state to trigger new search
    dispatch(setVendorsLoaded(false));
    dispatch(setResultsLoaded(false));
    history.push({
      pathname: `/${lng}/${routes.SEARCH}`,
      search
    });
  };

  return (
    <>
    <Navbar className="header" dir={rtl ? 'rtl' : 'ltr'} expand="false">
      <MyHelmet lng={lng} redirect={true}></MyHelmet>
        <div role="group" aria-label="Preferences" >
        <Login dir={dir} cid={cid} onMenuClick={() => trackMenuClick('LoginModal')} />
        <button onClick={() => { setShowLocaleModal(true); trackMenuClick('LocaleModal'); }} type="button" className="btn btn-lg">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" style={{ fill: "#87d6e4" }} className="bi bi-currency-exchange" viewBox="0 0 16 16">
            <path d="M0 5a5 5 0 0 0 4.027 4.905 6.5 6.5 0 0 1 .544-2.073C3.695 7.536 3.132 6.864 3 5.91h-.5v-.426h.466V5.05q-.001-.07.004-.135H2.5v-.427h.511C3.236 3.24 4.213 2.5 5.681 2.5c.316 0 .59.031.819.085v.733a3.5 3.5 0 0 0-.815-.082c-.919 0-1.538.466-1.734 1.252h1.917v.427h-1.98q-.004.07-.003.147v.422h1.983v.427H3.93c.118.602.468 1.03 1.005 1.229a6.5 6.5 0 0 1 4.97-3.113A5.002 5.002 0 0 0 0 5m16 5.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-7.75 1.322c.069.835.746 1.485 1.964 1.562V14h.54v-.62c1.259-.086 1.996-.74 1.996-1.69 0-.865-.563-1.31-1.57-1.54l-.426-.1V8.374c.54.06.884.347.966.745h.948c-.07-.804-.779-1.433-1.914-1.502V7h-.54v.629c-1.076.103-1.808.732-1.808 1.622 0 .787.544 1.288 1.45 1.493l.358.085v1.78c-.554-.08-.92-.376-1.003-.787zm1.96-1.895c-.532-.12-.82-.364-.82-.732 0-.41.311-.719.824-.809v1.54h-.005zm.622 1.044c.645.145.943.38.943.796 0 .474-.37.8-1.02.86v-1.674z"></path>
          </svg>
        </button>
        {hasHistory && (
          <>
            <button
              ref={historyBtnRef}
              onClick={() => {
                setShowRecentSearchesModal(true);
                trackMenuClick('RecentSearchesModal');
                dispatchRedux(dismissCoachmark());
                setShowCoachmark(false);
              }}
              type="button"
              className={`btn btn-lg position-relative${hasHistory && !coachmarkDismissed ? ' pulse-highlight' : ''}`}
              title={t('recentSearches') || 'Recent Searches'}
            >
              <FaHistory className="bi" size={24} color="#87d6e4" />
              {hasHistory && !coachmarkDismissed && (
                <span style={{
                  position: 'absolute',
                  top: 6,
                  right: 6,
                  fontSize: '1.2em',
                  color: 'red',
                  pointerEvents: 'none',
                  zIndex: 2
                }}>●</span>
              )}
            </button>
          </>
        )}
      </div>
      {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
      {/* <span className="d-lg-none">
        {wl ? (<span className='text-muted'>{t("poweredBy")} </span>): (<span></span>)}
        {t("brand")}
      </span> */}
      <span>
        {/* <span className="d-none d-lg-inline">
          {wl ? (<span className='text-muted'>{t("poweredBy")} </span>): (<span></span>)}
          {t("brand")}
        </span>&nbsp;&nbsp; */}
        <a href={`/${lng}/`}><img src="/logo.png" className='rounded' style={{ height: "58px" }} alt="paapmpaapm logo"></img></a>
      </span>
      {/* <Navbar.Collapse id="basic-navbar-nav">
        <span className="nav-link"><LanguageSwitch /></span>
        <span className="nav-link"><CurrencySwitch /></span>
    </Navbar.Collapse> */}
    </Navbar>
    <LanguageSuggestionBanner />
    <LocaleModal dir={dir} shouldShow={showLocaleModal} setModalVisible={setShowLocaleModal} ></LocaleModal>
    <RecentSearchesModal shouldShow={showRecentSearchesModal} setModalVisible={setShowRecentSearchesModal} locations={locations} currentSearchQuery={location.search} onResumeSearch={(params, filters) => openSearchPage(buildResumeQuery(params, filters))} onStartOverSearch={(params) => openSearchPage(buildStartOverQuery(params))} />
  </>
  )
}

const mapStateToProps = ({ vendors, results, ui, currencies, locations }) => ({
  dir: ui.direction,
  locations: locations.data,
  // lng: ui.language,
});

export default connect(mapStateToProps)(Header);